"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IGNORE_ERRORS = exports.BLACK_LIST_URLS = void 0;
// 黑名单
var BLACK_LIST_URLS = exports.BLACK_LIST_URLS = [/extensions\//i, /^chrome:\/\//i, /^chrome-extension:\/\//i, /webappstoolbarba\.texthelp\.com\//i, /wkbrs1\.tingyun\.com\//i, /metrics\.itunes\.apple\.com\.edgesuite\.net\//i, /map\.qq\.com\/api\/gljs/i // 忽略了腾讯地图的报错，因为第三方数据太不稳定，报错比较多
];

// 需要全局过滤的关键字规则
var IGNORE_ERRORS = exports.IGNORE_ERRORS = [/HTMLHeadElement.appendChild/, /Java object/, /responseText/, /WeixinJSBridge is not defined/gi, 'WeixinJSBridge', 'top.GLOBALS', 'originalCreateNotification', 'canvas.contentDocument', /webpack/gi, 'webpack', /Error: Timeout/, /window.zhuanzhuanMApplication.executeCmd/, /window.zhuanzhuanMApplication.executeCmd is not a function/, /window.zhuanzhuanM/, /zzcallback_/, /InvalidStateError: Failed to read/, /Loading chunk /, /ResizeObserver loop/, /zzcallbackV2_/, /zzcallback/, /nbsJsBridge.logDebug/,
// 开发调试工具
/nbsJsBridge.logJsResult/,
// 开发调试工具
/nbsJsBridge.sfp is not a function/,
// 开发调试工具
/_dsbridge.call is not a function/, /nbsDOMChanged.postMessage is not a function/, /Error: timeout/, /Network Error/gi, /window.ucbrowser/,
// UC浏览器插件报的问题过滤上报
/window.MiWebViewDetector/,
// 小米环境的探测器异常：window.MiWebViewDetector.onCatch is not a function
/window.bannerNight is not a function/,
// vivo 浏览器切换 夜间/日间模式
/window.changeNetWork is not a function/,
// Smartphone 切换 网络
'数据请求中，请稍后',
// Cancel: 数据请求中，请稍后---axios options请求，会被判为异常，应该以接口状态为主，因此可忽略
/网络异常，请稍后重试/, /网络开小差了，请稍后重试/, /验证码发送频繁,请稍后重试/, /网络开小差了/, /需要登录才可以访问/, /PerformanceObserver is not defined/, /https:\/\/goo.gl\/LdLk22/, /c35 is not defined/,
// 升级adapter
/runCustomize is not defined/,
// 客户端 ios webview错误
/安卓sdk执行错误/gi,
// 客户端andr webview错误
/ResizeObserver loop limit exceeded/,
// https://github.com/quasarframework/quasar/issues/2233
/Non-Error promise rejection captured with value: cancel/,
// 弹窗-取消按钮，正常操作
/Non-Error promise rejection captured with keys: message/,
// 此为接口（中间态）请求中：数据请求中，请稍后
/Object captured as promise rejection with keys: message/,
// 此为接口（中间态）请求中：数据请求中，请稍后
/Non-Error promise rejection captured with value: 没有操作权限/, 'Converting circular structure to JSON',
// 客服端引入的听云，主要是转转安卓上报
/Converting circular structure to JSON/,
// 客服端引入的听云，主要是转转安卓上报
/window._handleMessageFromNative/,
// 找靓机侧报：window._handleMessageFromNative is not a function，提供给native使用的方法，将消息塞进h5的消息接收队列，并进行消息分发，https://sentry.zhuanspirit.com/organizations/zhuanzhuan/issues/7165090
/Non-Error promise rejection captured with value: useRequest has caught the exception, if you need to handle the exception yourself, you can set options.throwOnError to true./, /Unexpected identifier 'TT'/,
// 这种是ios webview的问题，可以先忽略；根本原因是执行js种入cookie的时候，cookie的value需要编码，视频中的报错字段个别是前端的，由金鑫进行url encode编码支持，客户端这边的只有PPU，safe-ppu两个需要编码，iOS单独进行了处理。Android没有这个问题
/Unexpected identifier 'type'/,
// 在使用cookies的时候，存对象没编码
/Unexpected identifier 'refpagetype'/,
// 在使用cookies的时候，存对象没编码
/跨webview访问历史跟踪报错SyntaxError/,
// lego 主动上报,Sentry如果近日激增类似问题，升级@zz-common/lego@6.0.12 ，根因lego里面把zzVisitStack编码了，老版本解析异常
/vivoNewsDetailPage.getNewsReadStatus4Vivo/,
// vivo环境
/dscb\d+\s+is not defined/,
// 客户端sdk回调执行问题
/Navigation cancelled from/,
// 客户端错误
/checkGps is not defined/,
// 快狗打车-客户端错误 t=94
/titleForRightButton is not defined/,
// 快狗打车-客户端错误 t=94
/webViewDidAppear is not defined/,
// 快狗打车-客户端错误 t=94
/cordova is not defined/,
// 快狗打车-客户端错误 t=94
/backButtonClicked is not defined/,
// 快狗打车-客户端错误 t=94
/eruda is not defined/, /themeModeCallJs is not defined/, /onNightModeChanged is not defined/, /Non-Error promise rejection captured with value: overlay/,
// zz-ui弹窗得取消 or 蒙层关闭 点击事件没有catch
/processRandomSelector is not defined/,
// VivoBrowser 或此浏览器的附加组件，它在查看的网页上使用自己注入的 JS 代码
/downloadStatusCallback is not defined/,
// VivoBrowser 或此浏览器的附加组件，它在查看的网页上使用自己注入的 JS 代码
/downProgCallback is not defined/,
// VivoBrowser 或此浏览器的附加组件，它在查看的网页上使用自己注入的 JS 代码
/vivoNewsDetailPage.getNewsReadStatus4Vivo is not a function/,
//获取vivo新闻详情页中某篇新闻的阅读状态
/onNightModeChanged is not defined/,
//vivo 浏览器切换 夜间/日间模式的错误
/themeModeCallJs is not defined/,
//安兔兔cookie recoveryFrom：87
/undefined is not an object \(evaluating 'window.weixinPostMessageHandlers.weixinDispatchMessage.postMessage'\)/,
//在微信浏览器中用于发送消息的方法。它通常用于与微信客户端或嵌入网页的微信浏览器进行通信。未定义或不是对象
/No identifiers allowed directly after numeric literal/,
//在数字字面量之后不允许直接使用标识符-三方包
/ignoreError is not defined/,
//ignoreError未定义
/activeEvent is not defined/,
//Chrome Mobile WebView 69.0.3497
/x5onSkinSwitch is not defined/,
//QQBrowser/8.1 换肤
/Can't find variable: zzcallback_\d+_setPageCallback/,
//没走到业务代码
/Can't find variable: zzcallback_\d+_registerUnreadCountNotifyCallback/ //没走到业务代码
];